import {RPCService} from '../service/rpc-service';
import {
    CameraBrandModel,
    CameraModel,
    ControlModel,
    ControlTypeModel,
    InputModel,
    InputTypeModel,
    MediaModel,
    CallListModel,
    SensorTypeModel,
    UserModel,
} from '../types/control';
import {BridgeDeviceModel} from '../types/bridge-device';
import {
    AlarmStateModel,
    AreaModel,
    ConfigModel,
    MediaInputModel,
    VirtualControlModel,
    ScenarioModel,
    ScenarioTriggerModel,
    HomepageItemModel,
    SoundState,
    MenuEntity,
    STPUIEntity,
    LanguageModel,
    ScreenState,
    LogListType,
    IftttState,
    EnergyAnalyzerModel,
    ConnectionIcons,
    AuthorityModel,
    TimezoneType,
    AsyncAlarmState,
    SIPBlockedNumbersState,
    BoosterModel,
    SIPFormatType,
    SunTimeType,
    FrameUIEntity
} from "../store/control/state"
import {DoorModel} from '../types/door';
import {IntercomModel} from '../types/intercom';
import {SettingsModel} from '../store/settings/state';
import {setDefaultAlarmStateAction, setEntityListAction, setSoundStateAction, setLogAction, setConnectionIconsAction, setWorkerConfig, setSupervisorConfigListAction, setEnergyAnalyzer, setMousePointerAction, setHomepageItemsActions, setExternalUsbAction, setTimezoneAction, setSuntimeAction} from '../store/control/actions';
import {setSettingsAction} from '../store/settings/actions';
import {Dispatch} from 'react';
import {Action} from '../base/fsa/createAction';
import {batch} from 'react-redux';
import {setApplicationLoaded, setMediaFileListAction, setThemeAction} from '../store/ui/actions';
import {MediaFileModel, ThemeModel} from '../store/ui/state';
import {GatewayModel} from '../types/gateway';
import {DoorBrandModel} from '../types/door-brand';
import {BridgeDeviceTypeModel} from '../types/bridge-device-type';
import {LocationModel} from '../types/location';
import {setTemperatureAction} from '../store/temperature/action';
import {TemperatureMessage} from '../store/temperature/state';
import i18n from 'i18next';
import {ConciergeModel} from '../types/concierge';
import {ConciergeTypeModel} from '../types/concierge-type';
import {SupervisorConfigModel} from '../types/supervisor-config';
import { WorkerConfigModel } from '../types/worker-config';

let latestVersion = localStorage.getItem('latestVersion');
let preventReload = localStorage.getItem('preventReload') === 'true';
export async function fetchAndInitialize(rpc_service: RPCService, dispatch: Dispatch<Action>) {
    const sensorTypePromise = rpc_service.getSensorTypeList();
    const controlTypePromise = rpc_service.getControlTypeList();
    const userPromise = rpc_service.getUserList();
    const controlPromise = rpc_service.getControlList();
    const bridgeDevicePromise = rpc_service.getBridgeDeviceList();
    const bridgeDeviceTypePromise = rpc_service.getBridgeDeviceTypeList();
    const gatewayPromise = rpc_service.getGatewayList();
    const cameraPromise = rpc_service.getCameraList();
    const cameraBrandPromise = rpc_service.getCameraBrandList();
    const mediaFilePromise = rpc_service.getMediaFileList();
    const inputTypePromise = rpc_service.getInputTypeList();
    const inputPromise = rpc_service.getInputList();
    const scenarioPromise = rpc_service.getScenarioList();
    const scenarioTriggerPromise = rpc_service.getScenarioTriggerList();
    const doorPromise = rpc_service.getDoorList();
    const doorBrandPromise = rpc_service.getDoorBrandList();
    const intercomPromise = rpc_service.getIntercomList();
    const areaPromise = rpc_service.getAreaList();
    const mediaPromise = rpc_service.getMediaList();
    const mediaInputPromise = rpc_service.getMediaInputList();
    const virtualControlPromise = rpc_service.getVirtualControlList();
    const homepageItemPromise = rpc_service.getHomepageItemList();
    const alarmStatePromise = rpc_service.getAlarmState();
    const soundStatePromise = rpc_service.getSoundState();
    const screenStatePromise = rpc_service.getScreenState();
    const settingsPromise = rpc_service.getSettings();
    const configsPromise = rpc_service.getConfigs();
    const locationPromise = rpc_service.getLocationList();
    const temperaturePromise = rpc_service.getTemperature();
    const menuItemPromise = rpc_service.getMenuList();
    const stpUIPromise = rpc_service.getSTPUIList();
    const languagePromise = rpc_service.getLanguageList();
    const conciergePromise = rpc_service.getConciergeList();
    const conciergeTypePromise = rpc_service.getConciergeTypeList();
    const getLogListPromise = rpc_service.GetLogList()
    const iftttStatePromise = rpc_service.getIftttState();
    const getScreenPinPromise = rpc_service.getScreenPinCodeState()
    const getEnergyStatePromise = rpc_service.getEnergyMonitorGetConfig();
    //const getConnectionIconsPromise = rpc_service.GetConnIcons()
    const getSupervisorConfigPromise = rpc_service.getSupConfig();
    const getWorkerConfigPromise = rpc_service.getWorkerConfig();
    const getCallListPromise = rpc_service.getCallList();
    const getMousePointerPromise = rpc_service.getMouseCursorVisibility();
    const getAuthorityGroupListPromise = rpc_service.getAuthorityGroupList();
    const getHomepageItemsPromise = rpc_service.getHomepageItemsByGatewayStatus()
    const getExternalUsbPromise = rpc_service.getUsbConnectionStatus();
    const getTimezonePromise = rpc_service.getTimezoneList();
    const getAsyncAlarmTimerPromise = rpc_service.getAlarmTimerState();
    const getSIPBlockedListPromise = rpc_service.getCallBlockList();
    const getBoosterDeviceListPromise = rpc_service.getBoostedDeviceList();
    const getSIPFormatTypePromise = rpc_service.getSipFormatList();
    const getSuntimePromise = rpc_service.getSunriseSunset();
    const getFrameUIListPromise = rpc_service.getFrameUIList();
    const getUIThemePromise = rpc_service.getUITheme();
    await rpc_service.updateTimezoneOffset()

    const [
        sensorTypes,
        controlTypes,
        users,
        controls,
        bridgeDevices,
        bridgeDeviceTypes,
        gateways,
        cameras,
        cameraBrands,
        mediaFiles,
    ] = await Promise.all<SensorTypeModel[],
        ControlTypeModel[],
        UserModel[],
        ControlModel[],
        BridgeDeviceModel[],
        BridgeDeviceTypeModel[],
        GatewayModel[],
        CameraModel[],
        CameraBrandModel[],
        MediaFileModel[]>([
        sensorTypePromise,
        controlTypePromise,
        userPromise,
        controlPromise,
        bridgeDevicePromise,
        bridgeDeviceTypePromise,
        gatewayPromise,
        cameraPromise,
        cameraBrandPromise,
        mediaFilePromise,
    ]);

    const [
        inputTypes,
        inputs,
        scenarios,
        scenarioTriggers,
        doors,
        doorBrands,
        intercoms,
        areas,
        medias,
        mediaInputs,
    ] = await Promise.all<InputTypeModel[],
        InputModel[],
        ScenarioModel[],
        ScenarioTriggerModel[],
        DoorModel[],
        DoorBrandModel[],
        IntercomModel[],
        AreaModel[],
        MediaModel[],
        MediaInputModel[]>([
        inputTypePromise,
        inputPromise,
        scenarioPromise,
        scenarioTriggerPromise,
        doorPromise,
        doorBrandPromise,
        intercomPromise,
        areaPromise,
        mediaPromise,
        mediaInputPromise,
    ]);

    const [
        virtualControls,
        homepageItems,
        alarmState,
        soundState,
        settings,
        configs,
        locations,
        temperatureResponse,
        menuItems,
        stpUIs,
    ] = await Promise.all<
        VirtualControlModel[],
        HomepageItemModel[],
        AlarmStateModel,
        SoundState,
        SettingsModel,
        ConfigModel,
        LocationModel[],
        TemperatureMessage,
        MenuEntity[],
        STPUIEntity[]
    >([
        virtualControlPromise,
        homepageItemPromise,
        alarmStatePromise,
        soundStatePromise,
        settingsPromise,
        configsPromise,
        locationPromise,
        temperaturePromise,
        menuItemPromise,
        stpUIPromise,
    ]);

    const [
        languages,
        concierges,
        conciergeTypes,
        ifttt,
        screenState,
        logList,
        energyState,
        //connectionIcons,
        supervisorConfig,
        workerConfig,
    ] = await Promise.all<
        LanguageModel[],
        ConciergeModel[],
        ConciergeTypeModel[],
        IftttState,
        ScreenState,
        LogListType[],
        EnergyAnalyzerModel,
        //ConnectionIcons,
        SupervisorConfigModel,
        WorkerConfigModel
    >([
        languagePromise,
        conciergePromise,
        conciergeTypePromise,
        iftttStatePromise,
        screenStatePromise,
        getLogListPromise,
        getEnergyStatePromise,
        //getConnectionIconsPromise,
        getSupervisorConfigPromise,
        getWorkerConfigPromise,
    ]);

    const [
        pinScreen,
        callList,
        mousePointer,
        favoritesItems,
        externalUsb,
        authorityGroupList,
        timezoneList,
        alarmTimer,
        callBlockList,
        boosterList
    ] = await Promise.all<
        ScreenState,
        CallListModel[],
        boolean,
        boolean,
        boolean,
        AuthorityModel[],
        TimezoneType[],
        AsyncAlarmState,
        SIPBlockedNumbersState[],
        BoosterModel[]
    >([
        getScreenPinPromise,
        getCallListPromise,
        getMousePointerPromise,
        getHomepageItemsPromise,
        getExternalUsbPromise,
        getAuthorityGroupListPromise,
        getTimezonePromise,
        getAsyncAlarmTimerPromise,
        getSIPBlockedListPromise,
        getBoosterDeviceListPromise
    ])


    const [
        theme,
        SIPFormatTypeList,
        suntime,
        frameUIList
    ] = await Promise.all<
        ThemeModel,
        SIPFormatType[],
        SunTimeType,
        FrameUIEntity[]
    >([
        getUIThemePromise,
        getSIPFormatTypePromise,
        getSuntimePromise,
        getFrameUIListPromise
    ])


    let languageKeys = [];
    for (const lang of languages) {
        const languageGroup: Record<string, string> = {};
        Object.keys(lang.settings_variables).forEach((key) => {
            const subSettings = lang.settings_variables[key];
            Object.keys(subSettings).forEach((subKey) => {
                const fullKey = `${key}.${subKey}`;
                const value = subSettings[subKey];
                languageGroup[fullKey] = value;
            });
        });
        Object.assign(languageGroup, lang.variables);
        languageKeys.push({ id: lang.id, name: lang.name })
        i18n.addResources(lang.id, "translations", languageGroup);
    }

    const shouldReload = await shouldReloadPage(rpc_service, configs)
    if (shouldReload) { window.location.reload(); return; }

    batch(() => {

        dispatch(setEntityListAction(sensorTypes, 'sensorType'));
        dispatch(setEntityListAction(controlTypes, 'controlType'));
        dispatch(setEntityListAction(users, 'user'));
        dispatch(setEntityListAction(controls, 'control'));
        dispatch(setEntityListAction(bridgeDevices, 'bridgeDevice'));
        dispatch(setEntityListAction(bridgeDeviceTypes, 'bridgeDeviceType'));
        dispatch(setEntityListAction(gateways, 'gateway'));
        dispatch(setEntityListAction(cameras, 'camera'));
        dispatch(setEntityListAction(cameraBrands, 'cameraBrand'));
        dispatch(setEntityListAction(inputTypes, 'inputType'));
        dispatch(setEntityListAction(inputs, 'input'));
        dispatch(setEntityListAction(scenarios, 'scenario'));
        dispatch(setEntityListAction(scenarioTriggers, 'scenarioTrigger'));
        dispatch(setEntityListAction(doors, 'door'));
        dispatch(setEntityListAction(doorBrands, 'doorBrand'));
        dispatch(setEntityListAction(intercoms, 'intercom'));
        dispatch(setEntityListAction(areas, 'area'));
        dispatch(setEntityListAction(medias, 'media'));
        dispatch(setEntityListAction(mediaInputs, 'mediaInput'));
        dispatch(setEntityListAction(virtualControls, 'virtualControl'));
        dispatch(setEntityListAction(homepageItems, 'homepageItem'));
        dispatch(setEntityListAction(configs, 'config'));
        dispatch(setEntityListAction(locations, 'location'));
        dispatch(setEntityListAction(stpUIs, 'stpUI'));
        dispatch(setEntityListAction(languageKeys, 'language'));
        dispatch(setEntityListAction(concierges, 'concierge'));
        dispatch(setEntityListAction(conciergeTypes, 'conciergeType'));
        dispatch(setEntityListAction({...screenState, ...pinScreen}, "screenState"))
        dispatch(setEntityListAction(ifttt, 'ifttt'));
        dispatch(setEntityListAction(callList, "callList"))
        dispatch(setEntityListAction(authorityGroupList, "authorityGroup"))
        dispatch(setEntityListAction(alarmTimer, "alarmTimer"))
        dispatch(setEntityListAction(callBlockList, "callBlock"))
        dispatch(setEntityListAction(boosterList, "booster"))
        dispatch(setEntityListAction(SIPFormatTypeList, "sipFormatType"))
        dispatch(setEntityListAction(frameUIList, "frameUI"))
        if (temperatureResponse != null) {
            dispatch(setTemperatureAction(temperatureResponse.icon, temperatureResponse.temperature));
        }
        dispatch(setEntityListAction(menuItems, 'menu'));

        dispatch(setDefaultAlarmStateAction(alarmState));
        dispatch(setSoundStateAction(soundState));
        dispatch(setSettingsAction(settings));
        dispatch(setMediaFileListAction(mediaFiles || []));
        dispatch(setApplicationLoaded());
        dispatch(setLogAction(logList || []))
        //dispatch(setConnectionIconsAction(connectionIcons))
        dispatch(setSupervisorConfigListAction(supervisorConfig, "supConfig"))
        dispatch(setWorkerConfig(workerConfig))
        dispatch(setEnergyAnalyzer(energyState));
        dispatch(setMousePointerAction(mousePointer))
        dispatch(setHomepageItemsActions(favoritesItems))
        dispatch(setExternalUsbAction(externalUsb))
        dispatch(setTimezoneAction(timezoneList))
        dispatch(setSuntimeAction(suntime))
        dispatch(setThemeAction(theme))
    });
}


function shouldReloadPage(rpc_service: RPCService, configs: ConfigModel) {

    // This function checks if the page should be reloaded based on the system 
    //configuration and version.

    // If advanced authorization is enabled, we need to reload the page if the 
    // preventReload flag is NOT set to true.

    if (configs.advanced_authorization_status) {
        if (preventReload) {
            localStorage.setItem('preventReload', 'false');
            return false;
        }
        // Before reloading the page, set the preventReload flag to true to prevent
        // the page from being reloaded again.
        localStorage.setItem('preventReload', 'true');
        return true;
    }
    return rpc_service.getSystemInfo()
        .then(systemInfo => {
            if (latestVersion != null && systemInfo.version !== latestVersion) {
                localStorage.setItem('latestVersion', systemInfo.version);
                return true;
            }
            return false;
        })
        .catch(error => {
            console.error("Error fetching system info:", error);
            return false;
        });
    ;
}